import $axios from '~/plugins/axios';
import { buildModule } from '../utils';
import { Api, SettingPrinter } from '~/api';
import { createDict, Dict } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withState({
		storedPrinters: {} as Dict<SettingPrinter>,
		printers: [] as SettingPrinter[],
	})
	.withGetters({
		byId: state => (printerId: number): SettingPrinter | null => (
			state.storedPrinters[printerId] ?? null
		),
		items: state => state.printers,
	})
	.withMutations({
		SET_STORED_PRINTERS (state, printers: SettingPrinter[]) {
			state.storedPrinters = {
				...state.storedPrinters,
				...createDict(printers, (printer) => printer.id),
			};
		},
		SET_PRINTERS (state, printerIds: number[]) {
			state.printers = printerIds.map(id => state.storedPrinters[id]);
		},
	})
	.withActions({
		async get ({ commit }) {
			const { data } = await api.get('/setting/printer');

			const printers = data.payload;
			const printerIds = printers.map(printer => printer.id);

			commit('SET_STORED_PRINTERS', printers);
			commit('SET_PRINTERS', printerIds);
		},
	});
